import React, { useState, useCallback, useEffect } from 'react';
import { Form, Select } from 'antd';
import { getAiModels, getAiModelsLimits } from '../../utils/api.js';
import PropTypes from 'prop-types';
const { Option } = Select;

function ModelSelect({ defaultModel, onChange, onError }) {
	const [models, setModels] = useState([]);
	const [selected, setSelected] = useState(null);

	const getModels = useCallback(async () => {
		const availableModels = await getAiModels();
		const modelsLimits = await getAiModelsLimits();

		let usableModels = [];
		if (availableModels.length) {
			if (modelsLimits.length) {
				availableModels.forEach((model, index) => {
					const limit = modelsLimits.find((limit) => limit.modelId === model.id);

					if (limit) {
						usableModels.push({
							...model,
							tokenLimit: limit.tokenLimit,
						});
					}
				});
			}

			return usableModels;
		}
	}, [getAiModels, getAiModelsLimits]);

	const handleError = (message, description, level = 'error') => {
		onError(message, description, level);
	};

	useEffect(() => {
		const updateData = async () => {
			const newModels = await getModels();
			if (newModels) {
				setModels(newModels);

				const selectedIndex = newModels.findIndex((model) => model.id === defaultModel);
				if (selectedIndex !== -1) {
					setSelected(selectedIndex);
				}
			}
		};

		try {
			updateData();
		} catch (error) {
			handleError('Failed to load AI models', error.message);
		}
	}, []);

	useEffect(() => {
		if (selected !== null && onChange) {
			onChange(models[selected]);
		}
	}, [selected, onChange]);

	return (
		<Form.Item label='AI Modell' style={{ marginBottom: 12 }}>
			<Select
				size='default'
				style={{ width: '100%' }}
				defaultActiveFirstOption={true}
				onSelect={(value) => setSelected(value)}
				value={selected}
			>
				{models.map((model, index) => (
					<Option key={model.id} value={index}>
						{model.id.charAt(0).toUpperCase() + model.id.slice(1)} ({model.tokenLimit} tokens)
					</Option>
				))}
			</Select>
		</Form.Item>
	);
}

ModelSelect.propTypes = {
	onConfig: PropTypes.func,
	onError: PropTypes.func,
	defaultModel: PropTypes.string,
};

ModelSelect.defaultProps = {
	onConfig: () => {},
	onError: () => {},
	defaultModel: 'gpt-4',
};

export { ModelSelect, ModelSelect as default };



// WEBPACK FOOTER //
// ./src/components/ai/ModelSelect.jsx